const getters = {
  userName: state => state.user.userName,
  userInfo: state => state.user.userInfo,
}
export default getters
